import { getInicioEFimDoMes } from '~/graphql/pre-defined-filters/utils';

export default function () {
  const [inicioDoMes, finalDoMes] = getInicioEFimDoMes();
  return {
    where: {
      and: [
        {
          dataCriacao: {
            gte: inicioDoMes,
          },
        },
        {
          dataCriacao: {
            lte: finalDoMes,
          },
        },
      ],
    },
  };
}
